import React from "react";
import Joi from "joi-browser";
import HallOfFameTable from "./hallOfFameTable";
import { getHallOfFame } from "../../services/hallOfFameService";
import { getLeagues } from "../../services/leagueService";
import { getSeasons } from "../../services/seasonService";
import { getMatches } from "./../../services/matchService";
import Form from "../common/form/form";
import _ from "lodash";

class HallOfFame extends Form {
  state = {
    data: {
      league: 0,
      season: 0
    },
    errors: {},
    hallOfFame: [],
    leagues: [],
    leagueSeasons: [],
    seasons: []
  };

  schema = {
    league: Joi.number(),
    season: Joi.number()
  };

  async componentDidMount() {
    this.setState({
      leagues: _.orderBy(await getLeagues(), "name"),
      seasons: _.orderBy(await getSeasons(), "name", "desc")
    });

    const matches = await getMatches();
    const match = matches.find(m => m.isFinished === true);
    this.setState({ data: await this.setDefaultValues(match) });

    await this.displayHallOfFame(
      this.state.data.league,
      this.state.data.season
    );
  }

  async componentWillUpdate(nextProps, nextState) {
    let season = nextState.data.season;

    if (this.state.data.league !== nextState.data.league) {
      await this.setSeasons(nextState.data.league);

      if (
        this.state.leagueSeasons.length > 0 &&
        this.state.leagueSeasons.find(ls => ls.id === season) === undefined
      )
        season = this.state.leagueSeasons[0].id;
    }

    if (
      nextState.data.league === this.state.data.league &&
      season === this.state.data.season
    )
      return;

    await this.displayHallOfFame(nextState.data.league, season);
  }

  async setSeasons(leagueId) {
    let leagueSeasons = [];

    for (const s in this.state.seasons)
      if (
        this.state.seasons[s].leagues.find(l => l.id === +leagueId) !==
        undefined
      ) {
        leagueSeasons.push(this.state.seasons[s]);
      }

    this.setState({ leagueSeasons });
  }

  async setDefaultValues(match) {
    await this.setSeasons(match.league.id);

    return {
      league: match.league.id,
      season: match.season.id
    };
  }

  displayHallOfFame = async (league, season) => {
    const hallOfFame = await getHallOfFame(league, season);
    this.setState({ hallOfFame });

    const data = {
      league: league,
      season: season
    };
    this.setState({ data });
  };

  render() {
    const { hallOfFame, leagues, leagueSeasons } = this.state;

    return (
      <div>
        <h2>Hall Of Fame</h2>
        {this.renderSelect("league", "League", leagues, false)}
        {this.renderSelect("season", "Season", leagueSeasons, false)}
        <br />
        <br />
        <HallOfFameTable hallOfFame={hallOfFame} />
      </div>
    );
  }
}

export default HallOfFame;



// WEBPACK FOOTER //
// ./src/components/hallOfFame/hallOfFame.jsx